import type { AuthRepository } from '../../domain/repositories/AuthRepository.interface';
import type { AdminSession } from '../../domain/entities/AdminSession.entity';

/**
 * Reads the current session, if any. Returning `null` for "not signed in" is
 * intentional — the caller (a route loader) decides what to do about it
 * (redirect to /admin/login), it is not this use case's job to redirect.
 */
export class GetCurrentSessionUseCase {
  constructor(private readonly repository: AuthRepository) {}

  public async execute(): Promise<AdminSession | null> {
    return this.repository.getCurrentSession();
  }
}
